const enum I18nKey {
  LOGIN = "login",
  SIGNUP = "signup",
  SIGNUP_BTN = "signupBtn",
  TRYFREE_BTN = "tryFreeBtn",
  LOGOUT = "logout",
  TRIAL = "trial",
  ENGLISH = "english",
  CHINESE = "chinese",
  EXIT_GUIDE = "exitGuide",
  SCANQR_TITLE = "scanQrTitle",
  SIGNUP_CONFIRM_MSG = "signUpConfirmMsg",
  VERIFY_USER_CONFIRM_MSG = "verifyUserConfirmMsg",
  VERIFY_USER_LOGIN_MSG = "verifyUserLoginMsg",
  BILLING_INFO = "billingInformation",
  FORGOT_PASSWORD = "forgotPassword",
  NOT_VERIFIED = "notVerified",
  VERIFY_ACCOUNT = "verifyAccount",
  TRY_FREE_TITLE = "tryFreeTitle",
  TRY_FREE_SUBTITLE = "tryFreeSubTitle",
  PER_MONTH = "perMonth",
  PER_MONTH_SIGNUP = "perMonthSignUp",
  TERMS = "terms",
  SUBSCRIBE = "subscribe",
  DASHBOARD = "navigation.dashboard",
  TITLE = "navigation.title",
  SUBTITLE = "navigation.subtitle",
  CATALOG = "navigation.catalog",
  INVENTORY_POSITION = "navigation.inventoryPosition",
  MARKETING = "navigation.marketing",
  SHIPMENTS = "dashboard.shipment.title",
  SHIPMENTS_SUBTITLE_AGGREGATED = "dashboard.shipment.subtitleAggregated",
  REPORTS = "navigation.reports",
  SHIPMENTS_SUBTITLE = "dashboard.shipment.subtitle",
  PROMOTIONAL_CALENDER = "dashboard.promotionalCalender.title",
  PROMOTIONAL_CALENDER_SUBTITLE = "dashboard.promotionalCalender.subtitle",
  PERFORMANCE = "dashboard.performance.title",
  PERFORMANCE_DASHBOARD = "dashboard.performance.title",
  PERFORMANCE_DASHBOARD_SUBTITLE_AGGREGATED = "navigation.subtitleAggregated",
  PERFORMANCE_SUBTITLE = "dashboard.performance.subtitle",
  LISTING_HEALTH_TITLE = "dashboard.listingHealth.title",
  LISTING_HEALTH_SUBTITLE = "dashboard.listingHealth.subtitle",
  LISTING_HEALTH_SUBTITLE_AGGREGATED = "dashboard.listingHealth.subtitleAggregated",
  CATALOG_TRACKER = "dashboard.catalogTracker.title",
  CATALOG_TRACKER_MISMATCHES = "dashboard.catalogTracker.mismatches",
  UPDATE_CATALOG = "dashboard.options.updateCatalog",
  VIEW_AGGREGATE = "dashboard.options.viewAggregate",
  MAKE_HOME_PAGE = "dashboard.options.makeHomePage",
  COMING_SOON = "dashboard.comingSoon.title",
  SHARE_INPUT = "dashboard.comingSoon.subTitle",
  UPVOTE = "dashboard.comingSoon.upvote",
  VOTES = "dashboard.comingSoon.votes",
  OTHER_IDEAS = "dashboard.comingSoon.otherIdeas",
  SHARE_REQUESTS = "dashboard.comingSoon.shareRequests",
  SUBMIT = "dashboard.comingSoon.submit",
  WHITELABEL_TITLE = "dashboard.comingSoon.whiteLabel.title",
  WHITELABEL_CONTENT = "dashboard.comingSoon.whiteLabel.content",
  CONNECTIONS_TITLE = "dashboard.comingSoon.connections.title",
  CONNECTIONS_CONTENT = "dashboard.comingSoon.connections.content",
  BUY_BOX_TITLE = "dashboard.comingSoon.buyBox.title",
  BUY_BOX_CONTENT = "dashboard.comingSoon.buyBox.content",
  REVIEW_TRACKER_TITLE = "dashboard.comingSoon.reviewTracker.title",
  REVIEW_TRACKER_CONTENT = "dashboard.comingSoon.reviewTracker.content",
  RAW_DATA_ACCESS_TITLE = "dashboard.comingSoon.rawDataAccess.title",
  RAW_DATA_ACCESS_CONTENT = "dashboard.comingSoon.rawDataAccess.content",
  PROMO_CALENDAR_TITLE = "dashboard.comingSoon.promoCalendarTitle",
  SETTINGS = "dashboard.options.settings",
  SALES_CHANGES_TITLE = "dashboard.salesChanges.title",
  SALES_CHANGES_SUBTITLE = "dashboard.salesChanges.subtitle",
  SALES_CHANGES_SUBTITLE_AGGREGATED = "dashboard.salesChanges.subtitleAggregated",
  CATALOG_TRACKER_SUBTITLE = "dashboard.catalogTracker.subtitle",
  TOUR_BOX_HEALTH = "tour.health",
  TOUR_BOX_SUPPLYCHAIN = "tour.supplyChain",
  TOUR_BOX_BUSINESS = "tour.business",
  TOUR_BOX_SELLERACC = "tour.sellerAccount",
  VIEW_DETAILS_BTN = "tour.viewDetailsBtn",
  TOUR_LISTING_HEALTH = "tour.listingHealth",
  TOUR_CATALOG_TRACKER = "tour.catalogTracker",
  TOUR_REPLENISHMENT = "tour.replenishment",
  TOUR_SHIPMENTS = "tour.shipments",
  TOUR_FORCASTING = "tour.forcasting",
  TOUR_FULFILMENT_FEES = "tour.fulfillmentFees",
  TOUR_SALES = "tour.sales",
  TOUR_PERFORMANCE_DASHBOARD = "tour.performanceDashboard",
  TOUR_PAYMENTS = "tour.payments",
  TOUR_SIGNUP = "tour.signUp",
  TOUR_GUIDETITLE = "tour.guideTitle",
  TOUR_ONETOOL = "tour.oneTool",
  TOUR_GUIDESUBTITLE = "tour.guideSubTitle",
  TOUR_GUIDEINFO = "tour.guideBuiltInfo",
  TOUR_VIEW_PRICING = "tour.viewPricing",
  PRODUCT_SUBS_ERROR = "productSubsError",
  RESTOCK_SUMMARY = "replenishment.restockSummary",
  SELLER_LIMITS = "replenishment.sellerLimits",
  REPLENSISHMENTS = "replenishment.replenishments",
  REPLENSISHMENT = "dashboard.replenishment.title",
  REPLENSISHMENT_SUBTITLE = "dashboard.replenishment.subtitle",
  REPLENSISHMENT_SUBTITLEAGGREGATED = "dashboard.replenishment.subtitleAggregated",
  FULFILLMENT_FEES = "dashboard.fulfillmentFees.title",
  FULFILLMENT_FEES_SAVINGS = "dashboard.fulfillmentFees.potentialSavings",
  WIDGET_CATEGORY_INVENTORY = "widgetCategory.inventory",
  WIDGET_CATEGORY_REPORTS = "widgetCategory.reports",
  MERCHANT_FULFILLED = "merchantFulfilled",
  INVENTORY = "dashboard.category.inventory",
  ADVERTISING = "dashboard.category.advertising",
  SALES_VIEW_AND_REPORTS = "reports.salesViewAndReports",
  INVALID_EMAIL_PASSWORD = "err.invalid_email_password",
  EMAIL_ALREADY_EXISTS = "err.email_already_exists",
  NoCreditCardNeeded = "NoCreditCardNeeded",
  TERMS_AND_SERVICE_ERR = "termsAndServiceErr",
  APPLY = "apply",
  COLUMN = "column",
  VALUES = "values",
  UPLOAD = "upload",
  CREATE = "create",
  OK = "ok",
  APOLLO_SELECT_ALL = "apollo.selectAll",
  APOLLO_SELECT = "apollo.select",
  APOLLO_SEEDED_INFO = "apollo.seededInfo",
  APOLLO_NO_DISPUTE = "apollo.noDispute",
  APOLLO_DISPUTED = "apollo.disputed",
  APOLLO_COMPLETED = "apollo.completed",
  APOLLO_DISPUTABLE = "apollo.disputable",
  FORCASTING = "dashboard.forcasting.title",
  FORCASTING_SUBTITLE_AGGREGATED = "dashboard.forcasting.subtitleAggregated",
  FORCASTING_SUBTITLE = "dashboard.forcasting.subtitle",
  DISPUTABLE = "disputable",
  CREATE_SHIPMENT = "createShipmentBtn",
  PLAN_NAME = "createShipment.planName",
  SUMMARY_VIEW = "dashboard.catalogTracker.summaryView",
  ATTRIBUTES = "dashboard.catalogTracker.attributes",
  CALCULATOR = "calculator",
  DIMENSION_IMPROVEMENT = "dimension_improvement",
  CALCULATE = "calculate",
  CALCULATOR_TEMPLATE = "download_template",
  SALES_CHANGES = "salesChanges",
  BY_SELLERS = "by_sellers",
  BY_ASINS = "by_asins",
  VIEW = "viewTab",
  EDIT = "edit",
  INCREASE = "increase",
  DECREASE = "decrease",
  PERFORMANCE_DASHBOARD_TITLE = "performanceDashboard.title",
  SALES_DASHBOARD = "performanceDashboard.salesDashboard",
  SALES_BREAKOUT = "performanceDashboard.salesBreakout",
  SUMMARY_CHART = "performanceDashboard.summaryChart",
  SHIPMENT_STATUS = "performanceDashboard.shipmentStatus",
  RANK_CHANGES = "performanceDashboard.rankChanges",
  SIGNIFIANT_SALES_CHANGES = "performanceDashboard.significantSalesChanges",
  TABLE_VIEW = "view.tableView",
  SALES_DOLLARS = "salesDollars",
  SALES_GOALS_DOLLARS = "salesGoalsDollars",
  SALES_UNITS = "salesUnits",
  SALES_GOALS_UNITS = "salesGoalsUnits",
  Fba_Measurement = "fba_measurement",
  PAYMENTS = "navigation.payments",
  PAYMENTS_NET_MARGIN = "navigation.netMargin",
  PNLVIEW = "payment.pnlView",
  AMAZON_PAYMENT = "payment.amazonPayment",
  PAYMENT_INVENTORY = "payment.inventory",
  ACCOUNTING = "payment.accounting",
  SELLER = "seller",
  COMPANY = "company",
  ADD_NEW_ACCOUNT = "add_new_account",
  SELLER_NAME = "seller_name",
  MARKETPLACE = "marketplace",
  USERS = "users",
  EMAIL = "email",
  PHONE = "phone",
  ROLE = "role",
  NAME = "name",
  CODE = "code",
  ADD_NEW_USER = "addNewUser.title",
  USER_ERROR_MSG = "addNewUser.fieldMsg",
  SELLER_ERROR_MSG = "addNewUser.sellerMsg",
  EDIT_USER = "edit_user",
  TRIAL_ENDS = "subscription.trialEnd",
  CANCEL = "cancel",
  CHAT_LIVE = "chatLive",
  YOUR_EMAIL = "your_email",
  ATTACH_FILE = "attach_file",
  FILE_SIZE = "file_size",
  PAYMENT_SUBTITLE = "payment.payment_subtitle",
  PAYMENT_DATE_VALIDATION = "payment.date_validation_message",
  ANALYTICS = "analytics",
  NO_DATA_MSG = "no_data_msg",
  DEMO_DATA_DISPLAY = "demoDataBox.title",
  MOBILE_TEXT_OPTIMIZE = "demoDataBox.optimizeMsg",
  LOGIN_TO = "demoDataBox.login",
  SELLER_ACCOUNT = "demoDataBox.sellerAccount",
  ACCEPTED = "trialMessage.accepted",
  PASSWORD_CHARACTERS = "passwordValidation.characters",
  PASSWORD_CAPLETTER = "passwordValidation.capLetter",
  PASSWORD_SPECIAL_SYMBOL = "passwordValidation.specialSymbol",
  PASSWORD_NUMBER = "passwordValidation.number",
  PASSWORD_SMALL_LETTER = "passwordValidation.smallLetter",
  PASSWORD_NO_SPECIAL_SYMBOL = "passwordValidation.noSpecialSymbol",
  PASSWORD_VALID_CREDENTIALS = "passwordValidation.validCredentials",
  BTN_YES = "yes",
  BTN_NO = "no",
  SIGNIN_SUCCESS = "signIn.success",
  SIGNIN_INPUTFIELD = "signIn.inputField",
  SIGNIN_PASSWORD = "signIn.password",
  SIGNUP_SUCCESS = "signupValidation.success",
  OTP_SUCCESS = "signupValidation.otpSuccess",
  OTP = "signupValidation.otp",
  RESEND_CODE = "signupValidation.resendCode",
  VERIFY_CODE = "signupValidation.verifyCode",
  NO_USERNAME = "signupValidation.noUsername",
  ENTER_PASSWORD = "signupValidation.enterPassword",
  RE_ENTER_PASSWORD = "signupValidation.reEnterPassword",
  MOBILE_EMAIL = "signupValidation.mobileEmail",
  TERMS_AND_CONDITIONS = "signupValidation.termsConditions",
  PASSWORD_MISMATCH = "signupValidation.passwordMismatch",
  INVALID_EMAIL = "signupValidation.invalidEmail",
  COUNTRY_CODE = "signupValidation.countryCode",
  CREATE_ACCOUNT = "signupUI.createAccount",
  REENTER_PASSWORD = "signupUI.reEnterPassword",
  SIGNUP_CANCEL = "signupUI.cancel",
  SIGNUP_BUTTON = "signupUI.signUp",
  EXIT_SIGNUP = "confirmExitSignUp",
  EXIT_VERIFICATION = "confirmExitVerification",
  CONFIRM = "signupUI.confirm",
  AMAZON_ACCOUNT = "errorSellers.sellerAccount",
  AD_ACCOUNT = "errorSellers.adAccount",
  FULLFILLMENT = "dashboard.fullfillment.title",
  FULLFILLMENT_SUBTITLE_DEFAULT = "dashboard.fullfillment.subtitleDefault",
  ESTIMATED_LAUNCH_DATE = "dashboard.estimatedDate.title",
  NO_DATA = "dashboard.noData.title",
  DEMO_USER = "demoUser",
  WIDGET_TILES_SELLERS = "widgetTiles.sellers",
  WIDGET_TILES_SALES = "widgetTiles.lastWeekSales",
  WIDGET_TILES_SUPPRESSED_ITEMS = "widgetTiles.suppressedItems",
  WIDGET_TILES_INVENTORY_NEEDED = "widgetTiles.inventoryNeeded",
  WIDGET_TILES_FEE_SAVINGS = "widgetTiles.feeSavings",
  WIDGET_TILES_MISSING_UNITS = "widgetTiles.missingUnits",
  WIDGET_BOX_INVERTED_STRANDED = "widgetBoxInverted.stranded",
  WIDGET_BOX_INVERTED_INVENTORY = "widgetBoxInverted.Inventory",
  ASIN_COPIED = "asinCopied",
  ALERTPOPUP_SUBMITTING = "alertPopUp.submitting",
  ALERTPOPUP_SAVE = "alertPopUp.save",
  ALERTPOPUP_CLOSE = "alertPopUp.close",
  SELLER_CREATION_ADD_ACCOUNT = "loginOnBoarding.sellerCreation.addAccount",
  SELLER_CREATION_PRIMARY_SELLER = "loginOnBoarding.sellerCreation.primarySeller",
  SELLER_CREATION_PRIMARY_USER = "loginOnBoarding.sellerCreation.primaryUser",
  SELLER_CREATION_NOTE = "loginOnBoarding.sellerCreation.note",
  SELLER_CREATION_NEED_HELP = "loginOnBoarding.sellerCreation.needHelp",
  SELLER_CREATION_LINK = "loginOnBoarding.sellerCreation.link",
  SELLERS_FILTER_SELLERS = "loginOnBoarding.sellerFilter.sellers",
  SELLERS_FILTER_CANCEL = "loginOnBoarding.sellerFilter.cancel",
  SELLERS_FILTER_APPLY = "loginOnBoarding.sellerFilter.apply",
  SELLERS_FILTER_SELLER = "loginOnBoarding.sellerFilter.seller",
  SELLER_MODAL_SELLER_CREATED = "loginOnBoarding.sellerModal.sellerCreated",
  SELLER_MODAL_CLOSE = "loginOnBoarding.sellerModal.close",
  SELLER_MODAL_SELLER_NAME = "loginOnBoarding.sellerModal.sellerName",
  SELLER_MODAL_REQUIRED_FIELDS = "loginOnBoarding.sellerModal.requiredFields",
  SELLER_MODAL_CANCEL = "loginOnBoarding.sellerModal.cancel",
  SELLER_MODAL_CREATE_SELLER = "loginOnBoarding.sellerModal.createSeller",
  LOGIN_ONBOARDING_FREE_TRIAL = "loginOnBoarding.index.freeTrial",
  LOGIN_ONBOARDING_SUBSCRIPTION = "loginOnBoarding.index.subscription",
  LOGIN_ONBOARDING_SUBSCRIPTION_ENDED = "loginOnBoarding.index.subscriptionEnded",
  LOGIN_ONBOARDING_SUBSCRIBE = "loginOnBoarding.index.subscribe",
  LOGIN_ONBOARDING_BTN_SUBSCRIBE = "loginOnBoarding.index.subscribeBtn",
  SELLERS_LIST_SELLER = "loginOnBoarding.sellerList.seller",
  SELLERS_LIST_CLEAR = "loginOnBoarding.sellerList.clear",
  SELLER_INDEX_CONNECT = "loginOnBoarding.sellerIndex.connect",
  SELLER_INDEX_CONNECTED = "loginOnBoarding.sellerIndex.connected",
  ADD_SELLER_NO_SELLER = "usersPopUp.addSeller.noSeller",
  USER_MODAL_USER_CREATED = "usersPopUp.userModal.userCreated",
  USER_MODAL_CLOSE = "usersPopUp.userModal.close",
  USER_MODAL_CANCEL = "usersPopUp.userModal.cancel",
  USER_MODAL_INVITATION = "usersPopUp.userModal.invitation",
  USER_MODAL_USERNAME = "usersPopUp.userModal.userName",
  USER_MODAL_EMAIL = "usersPopUp.userModal.email",
  EDIT_USER_MODAL_FIELDS = "usersPopUp.userModalEdit.fields",
  EDIT_USER_MODAL_USER_UPDATED = "usersPopUp.userModalEdit.userUpdated",
  EDIT_USER_MODAL_CLOSE = "usersPopUp.userModalEdit.close",
  EDIT_USER_MODAL_EMAIL = "usersPopUp.userModalEdit.email",
  EDIT_USER_MODAL_USERNAME = "usersPopUp.userModalEdit.userName",
  EDIT_USER_MODAL_CANCEL = "usersPopUp.userModalEdit.cancel",
  EDIT_USER_MODAL_SAVE_USER = "usersPopUp.userModalEdit.saveUser",
  REPLENISHMENT_CHART_SELLERS = "replenishment.replenishmentChart.sellers",
  REPLENISHMENT_CHART_UNITS = "replenishment.replenishmentChart.units",
  REPLENISHMENT_CHART_AMAZON = "replenishment.replenishmentChart.amazon",
  REPLENISHMENT_CHART_TRANSIT = "replenishment.replenishmentChart.transit",
  REPLENISHMENT_CHART_NEEDED = "replenishment.replenishmentChart.needed",
  REPLENISHMENT_CHART_NO_DATA = "replenishment.replenishmentChart.noData",
  REPLENISHMENT_HEADER_PLANNING = "replenishment.replenishmentHeader.planning",
  REPLENISHMENT_HEADER_FBA = "replenishment.replenishmentHeader.fba",
  REPLENISHMENT_HEADER_DASHBOARD = "replenishment.replenishmentHeader.dashboard",
  REPLENISHMENT_HEADER_PLAN = "replenishment.replenishmentHeader.plan",
  REPLENISHMENT_HEADER_STEP = "replenishment.replenishmentHeader.step",
  REPLENISHMENT_HEADER_AMAZON_SELLER_ACCOUNT = "replenishment.replenishmentHeader.sellerAccount",
  REPLENISHMENT_HEADER_STEP2 = "replenishment.replenishmentHeader.step2",
  REPLENISHMENT_HEADER_PLANNING_VIEW = "replenishment.replenishmentHeader.planningView",
  REPLENISHMENT_HEADER_OPTIONAL = "replenishment.replenishmentHeader.optional",
  REPLENISHMENT_HEADER_MOST_ACCURATE = "replenishment.replenishmentHeader.accurate",
  REPLENISHMENT_HEADER_FORECAST = "replenishment.replenishmentHeader.forecast",
  REPLENISHMENT_HEADER_FORECAST_PAGE = "replenishment.replenishmentHeader.forecastPage",
  REPLENISHMENT_HEADER_INBOUND = "replenishment.replenishmentHeader.inbound",
  REPLENISHMENT_HEADER_KNOWN_INBOUND = "replenishment.replenishmentHeader.knownInbound",
  REPLENISHMENT_HEADER_GOALS = "replenishment.replenishmentHeader.goals",
  REPLENISHMENT_HEADER_DAYS = "replenishment.replenishmentHeader.days",
  REPLENISHMENT_HEADER_INVENTORY = "replenishment.replenishmentHeader.inventory",
  REPLENISHMENT_HEADER_OUTSIDE_FBA = "replenishment.replenishmentHeader.outsideFBA",
  REPLENISHMENT_HEADER_CLIENT = "replenishment.replenishmentHeader.client",
  REPLENISHMENT_HEADER_UNITS = "replenishment.replenishmentHeader.units",
  REPLENISHMENT_HEADER_ROUNDING = "replenishment.replenishmentHeader.rounding",
  REPLENISHMENT_HEADER_PREFERENCE = "replenishment.replenishmentHeader.preference",
  REPLENISHMENT_HEADER_CASE_PACK = "replenishment.replenishmentHeader.pack",
  REPLENISHMENT_HEADER_SELLING_UNITS = "replenishment.replenishmentHeader.sellingUnits",
  REPLENISHMENT_HEADER_PALLET = "replenishment.replenishmentHeader.pallet",
  REPLENISHMENT_HEADER_SELLING_UNITS_PALLET = "replenishment.replenishmentHeader.unitsPallet",
  REPLENISHMENT_HEADER_SHIP = "replenishment.replenishmentHeader.ship",
  REPLENISHMENT_HEADER_PREFERENCE_SHIPMENT = "replenishment.replenishmentHeader.preferenceShipment",
  REPLENISHMENT_HEADER_LOCATION = "replenishment.replenishmentHeader.location",
  REPLENISHMENT_HEADER_ORIGIN_SHIPMENT = "replenishment.replenishmentHeader.originShipment",
  REPLENISHMENT_HEADER_SHIPMENT_COST = "replenishment.replenishmentHeader.shipmentCost",
  REPLENISHMENT_HEADER_COST_PER_ROUNDING = "replenishment.replenishmentHeader.costPerRounding",
  REPLENISHMENT_HEADER_STEP3 = "replenishment.replenishmentHeader.step3",
  REPLENISHMENT_HEADER_CLICK_BACK = "replenishment.replenishmentHeader.clickBack",
  REPLENISHMENT_HEADER_STEP4 = "replenishment.replenishmentHeader.step4",
  REPLENISHMENT_HEADER_CREATE_SHIPMENT = "replenishment.replenishmentHeader.createShipment",
  REPLENISHMENT_HEADER_STEP5 = "replenishment.replenishmentHeader.step5",
  REPLENISHMENT_HEADER_UPLOAD_SHIPPING = "replenishment.replenishmentHeader.uploadShipping",
  REPLENISHMENT_HEADER_TITLE_INVENTORY = "replenishment.replenishmentHeader.titleInventory",
  REPLENISHMENT_SELLER_LIST_SELLER_SELECTED = "replenishment.sellerList.sellerSelected",
  REPLENISHMENT_TABLE_SELLER = "replenishment.replenishmentTable.seller",
  REPLENISHMENT_TABLE_ASIN = "replenishment.replenishmentTable.asin",
  REPLENISHMENT_TABLE_DESCRIPTION = "replenishment.replenishmentTable.description",
  REPLENISHMENT_TABLE_FBA = "replenishment.replenishmentTable.fba",
  REPLENISHMENT_TABLE_AVERAGE = "replenishment.replenishmentTable.average",
  REPLENISHMENT_TABLE_FORECAST = "replenishment.replenishmentTable.forecast",
  REPLENISHMENT_TABLE_MANUAL_FORECAST = "replenishment.replenishmentTable.manualForecast",
  REPLENISHMENT_TABLE_INBOUND = "replenishment.replenishmentTable.inbound",
  REPLENISHMENT_TABLE_INBOUND_MANUAL = "replenishment.replenishmentTable.inboundManual",
  REPLENISHMENT_TABLE_INBOUND_AMAZON = "replenishment.replenishmentTable.amazon",
  REPLENISHMENT_TABLE_TOTAL_INVENTORY = "replenishment.replenishmentTable.totalInventory",
  REPLENISHMENT_TABLE_SUPPLY_GOAL = "replenishment.replenishmentTable.supplyGoal",
  REPLENISHMENT_TABLE_FT_USAGE = "replenishment.replenishmentTable.ftUsage",
  REPLENISHMENT_TABLE_DOS = "replenishment.replenishmentTable.dos",
  REPLENISHMENT_TABLE_TARGET_UNITS = "replenishment.replenishmentTable.targetUnits",
  REPLENISHMENT_TABLE_GOAL = "replenishment.replenishmentTable.goal",
  REPLENISHMENT_TABLE_INVENTORY_AMAZON = "replenishment.replenishmentTable.inventoryAmazon",
  REPLENISHMENT_TABLE_SHIPMENT_GOAL = "replenishment.replenishmentTable.shipmentGoal",
  REPLENISHMENT_TABLE_THRESHOLD = "replenishment.replenishmentTable.threshold",
  REPLENISHMENT_TABLE_CASE_PACK = "replenishment.replenishmentTable.casePack",
  REPLENISHMENT_TABLE_PALLET_QUANTITY = "replenishment.replenishmentTable.palletQty",
  REPLENISHMENT_TABLE_ROUNDING_QTY = "replenishment.replenishmentTable.roundingQty",
  REPLENISHMENT_TABLE_SHIP_GOAL = "replenishment.replenishmentTable.shipGoal",
  REPLENISHMENT_TABLE_THRESHOLD_QTY = "replenishment.replenishmentTable.thresholdQty",
  REPLENISHMENT_TABLE_UPDATED_DATE = "replenishment.replenishmentTable.updatedDate",
  REPLENISHMENT_TABLE_SUBMITTING = "replenishment.replenishmentTable.submitting",
  REPLENISHMENT_TABLE_CLOSE = "replenishment.replenishmentTable.close",
  REPLENISHMENT_TABLE_PRODUCT_INFORMATION = "replenishment.replenishmentTable.productInfo",
  REPLENISHMENT_TABLE_SALES_VOLUME = "replenishment.replenishmentTable.salesVolume",
  REPLENISHMENT_TABLE_CURRENT_INVENTORY = "replenishment.replenishmentTable.currentInventory",
  REPLENISHMENT_TABLE_LIMITATIONS = "replenishment.replenishmentTable.limitations",
  REPLENISHMENT_TABLE_ROUNDING_LIMITATIONS = "replenishment.replenishmentTable.roundingLimitations",
  REPLENISHMENT_TABLE_OTHER_DETAILS = "replenishment.replenishmentTable.otherDetails",
  REPLENISHMENT_TABLE_DOWNLOAD_PROGRESS = "replenishment.replenishmentTable.progress",
  REPLENISHMENT_TABLE_DOWNLOAD_COMPLETE = "replenishment.replenishmentTable.complete",
  REPLENISHMENT_TABLE_EXPORTED = "replenishment.replenishmentTable.exported",
  REPLENISHMENT_TABLE_TOOLTIP_FBA = "replenishment.replenishmentTable.toolTipFBA",
  REPLENISHMENT_TABLE_TOOLTIP_CUBIC = "replenishment.replenishmentTable.toolTipCubic",
  REPLENISHMENT_TABLE_TOOLTIP_30DAY = "replenishment.replenishmentTable.toolTip30Day",
  REPLENISHMENT_TABLE_TOOLTIP_AUTO_UPDATE = "replenishment.replenishmentTable.toolTipAutoUpdate",
  REPLENISHMENT_TABLE_TOOLTIP_OPTIONAL = "replenishment.replenishmentTable.toolTipOptional",
  REPLENISHMENT_TABLE_TOOLTIP_AMAZON = "replenishment.replenishmentTable.toolTipAmazon",
  REPLENISHMENT_TABLE_TOOLTIP_MANUAL_ADJUST = "replenishment.replenishmentTable.toolTipManualAdjust",
  REPLENISHMENT_TABLE_TOOLTIP_FC_TRANSFER = "replenishment.replenishmentTable.fcTransfer",
  REPLENISHMENT_TABLE_TOOLTIP_INBOUND_AMAZON = "replenishment.replenishmentTable.inboundAmazon",
  REPLENISHMENT_TABLE_TOOLTIP_DAYS_SUPPLY = "replenishment.replenishmentTable.daysSupply",
  REPLENISHMENT_TABLE_TOOLTIP_FT_USAGE = "replenishment.replenishmentTable.fTUsage",
  REPLENISHMENT_TABLE_TOOLTIP_STORED_FBA = "replenishment.replenishmentTable.storedFBA",
  REPLENISHMENT_TABLE_TOOLTIP_DOS_NEEDED = "replenishment.replenishmentTable.dosNeeded",
  REPLENISHMENT_TABLE_TOOLTIP_DOS_GOAL = "replenishment.replenishmentTable.dosGoal",
  REPLENISHMENT_TABLE_TOOLTIP_MAX_SHIPMENT = "replenishment.replenishmentTable.maxShipment",
  REPLENISHMENT_TABLE_TOOLTIP_SUPPLY_GOAL = "replenishment.replenishmentTable.daysSupplyGoal",
  REPLENISHMENT_TABLE_TOOLTIP_PALLET = "replenishment.replenishmentTable.pallet",
  REPLENISHMENT_TABLE_TOOLTIP_PER_CASE_PACK = "replenishment.replenishmentTable.perCasePack",
  REPLENISHMENT_TABLE_TOOLTIP_UNITS_PER_PALLET = "replenishment.replenishmentTable.unitsPerPallet",
  REPLENISHMENT_TABLE_TOOLTIP_QTY_THRESHOLD = "replenishment.replenishmentTable.qtyThreshold",
  REPLENISHMENT_TABLE_TOOLTIP_SELLER_AVAILABILITY = "replenishment.replenishmentTable.sellerAvailability",
  REPLENISHMENT_TABLE_TOOLTIP_INVENTORY_NEEDS = "replenishment.replenishmentTable.inventoryNeeds",
  REPLENISHMENT_TABLE_TOOLTIP_UPDATED_DATE = "replenishment.replenishmentTable.updatedDateToolTip",
  REPLENISHMENT_TABLE_JOB_STATUS = "replenishment.replenishmentTable.jobStatus",
  REPLENISHMENT_TABLE_CHANGES = "replenishment.replenishmentTable.changes",
  REPLENISHMENT_TABLE_SUCCESS = "replenishment.replenishmentTable.success",
  REPLENISHMENT_TABLE_REFRESH = "replenishment.replenishmentTable.refresh",
  REPLENISHMENT_TABLE_RECALCULATE = "replenishment.replenishmentTable.recalculate",
  CREATE_MODAL_ASIN = "replenishment.shipmentCreateModal.asin",
  CREATE_MODAL_UNITS = "replenishment.shipmentCreateModal.units",
  CREATE_MODAL_CASES = "replenishment.shipmentCreateModal.cases",
  CREATE_MODAL_QTY = "replenishment.shipmentCreateModal.qty",
  CREATE_MODAL_ACTIONS = "replenishment.shipmentCreateModal.actions",
  CREATE_MODAL_CREATE_SHIPMENT = "replenishment.shipmentCreateModal.createShipment",
  CREATE_MODAL_CANCEL = "replenishment.shipmentCreateModal.cancel",
  CREATE_MODAL_DOWNLOAD_TEXT = "replenishment.shipmentCreateModal.text",
  CREATE_MODAL_DOWNLOAD_EXCEL = "replenishment.shipmentCreateModal.excel",
  CREATE_MODAL_PLAN_NAME = "replenishment.shipmentCreateModal.planName",
  CREATE_MODAL_SHIP_COUNTRY = "replenishment.shipmentCreateModal.shipCountry",
  CREATE_MODAL_ADDRESS = "replenishment.shipmentCreateModal.address",
  CREATE_MODAL_ADDRESS1 = "replenishment.shipmentCreateModal.address1",
  CREATE_MODAL_ADDRESS2 = "replenishment.shipmentCreateModal.address2",
  CREATE_MODAL_CITY = "replenishment.shipmentCreateModal.city",
  CREATE_MODAL_COUNTRY_CODE = "replenishment.shipmentCreateModal.countryCode",
  CREATE_MODAL_STATE_REGION = "replenishment.shipmentCreateModal.stateRegion",
  CREATE_MODAL_POSTAL_CODE = "replenishment.shipmentCreateModal.postalCode",
  CREATE_MODAL_DISTRICT = "replenishment.shipmentCreateModal.district",
  CREATE_MODAL_SHIPPING_METHOD = "replenishment.shipmentCreateModal.shippingMethod",
  REPLENISHMENT_INDEX_PRODUCT_INFO = "replenishment.index.productInfo",
  REPLENISHMENT_INDEX_SALES_VOLUME = "replenishment.index.salesVolume",
  REPLENISHMENT_INDEX_INVENTORY_GOALS = "replenishment.index.inventoryGoals",
  REPLENISHMENT_INDEX_LIMITATIONS = "replenishment.index.limitations",
  REPLENISHMENT_INDEX_ROUNDING_LIMITATIONS = "replenishment.index.roundingLimitations",
  REPLENISHMENT_INDEX_AMAZON_CAPACITY = "replenishment.index.amazonCapacity",
  REPLENISHMENT_INDEX_MANUAL_ADJUSTMENTS = "replenishment.index.manualAdjustments",
  REPLENISHMENT_INDEX_OTHER_DETAILS = "replenishment.index.otherDetails",
  SHIPMENTS_BAR_CHART_WEEKS = "dashboard.shipment.barChart.52weeks",
  SHIPMENTS_BAR_CHART_MISSING_UNITS = "dashboard.shipment.barChart.missingUnits",
  SHIPMENTS_BAR_CHART_RESOLVED = "dashboard.shipment.barChart.resolved",
  SHIPMENTS_BAR_CHART_DISPUTED = "dashboard.shipment.barChart.disputed",
  SHIPMENTS_BAR_CHART_NO_DISPUTE = "dashboard.shipment.barChart.noDispute",
  SHIPMENTS_BAR_CHART_NO_DATA = "dashboard.shipment.barChart.noData",
  SHIPMENTS_TABLE_SELLER = "dashboard.shipment.shipmentTable.seller",
  SHIPMENTS_TABLE_SELLER_TOOLTIP = "dashboard.shipment.shipmentTable.sellerToolTip",
  SHIPMENTS_TABLE_SHIPMENT_NO = "dashboard.shipment.shipmentTable.shipmentNo",
  SHIPMENTS_TABLE_SHIPMENT_NO_TOOLTIP = "dashboard.shipment.shipmentTable.shipmentNoToolTip",
  SHIPMENTS_TABLE_SHIPMENT_NAME = "dashboard.shipment.shipmentTable.shipmentName",
  SHIPMENTS_TABLE_SHIPMENT_NAME_TOOLTIP = "dashboard.shipment.shipmentTable.shipmentNameToolTip",
  SHIPMENTS_TABLE_SENT_UNITS = "dashboard.shipment.shipmentTable.sentUnits",
  SHIPMENTS_TABLE_UNITS_SHIPPED = "dashboard.shipment.shipmentTable.unitsShipped",
  SHIPMENTS_TABLE_RECEIVED_UNITS = "dashboard.shipment.shipmentTable.receivedUnits",
  SHIPMENTS_TABLE_UNITS_RECEIVED = "dashboard.shipment.shipmentTable.unitsReceived",
  SHIPMENTS_TABLE_MISSING_UNITS = "dashboard.shipment.shipmentTable.missingUnits",
  SHIPMENTS_TABLE_DIFFERENCE = "dashboard.shipment.shipmentTable.difference",
  SHIPMENTS_TABLE_UPDATED_DATE = "dashboard.shipment.shipmentTable.updatedDate",
  SHIPMENTS_TABLE_LAST_DATE = "dashboard.shipment.shipmentTable.lastDate",
  SHIPMENTS_TABLE_STATUS = "dashboard.shipment.shipmentTable.status",
  SHIPMENTS_TABLE_SHIPMENT_STATUS = "dashboard.shipment.shipmentTable.shipmentStatus",
  SHIPMENTS_TABLE_ACTION = "dashboard.shipment.shipmentTable.action",
  SHIPMENTS_TABLE_OPTIONAL_MANUAL = "dashboard.shipment.shipmentTable.optionalManual",
  SHIPMENTS_TABLE_NOT_DISPUTABLE = "dashboard.shipment.shipmentTable.notDisputable",
  SHIPMENTS_TABLE_NOT_DISPUTED = "dashboard.shipment.shipmentTable.notDisputed",
  SHIPMENTS_TABLE_DISPUTED = "dashboard.shipment.shipmentTable.disputed",
  SHIPMENTS_TABLE_RESOLVED = "dashboard.shipment.shipmentTable.resolved",
  SHIPMENTS_TABLE_CASE_ID = "dashboard.shipment.shipmentTable.caseId",
  SHIPMENTS_TABLE_MANUAL_TICKET = "dashboard.shipment.shipmentTable.manualTicket",
  SHIPMENTS_TABLE_ADD_NOTES = "dashboard.shipment.shipmentTable.addNotes",
  SHIPMENTS_TABLE_MANUAL_NOTES = "dashboard.shipment.shipmentTable.manualNotes",
  SHIPMENTS_TABLE_SAVE = "dashboard.shipment.shipmentTable.save",
  SHIPMENTS_TABLE_SUBMITTING = "dashboard.shipment.shipmentTable.submitting",
  SHIPMENTS_TABLE_RECORD_SAVED = "dashboard.shipment.shipmentTable.recordSaved",
  SHIPMENTS_TABLE_DOWNLOAD_PROGRESS = "dashboard.shipment.shipmentTable.progress",
  SHIPMENTS_TABLE_DOWNLOAD_COMPLETE = "dashboard.shipment.shipmentTable.complete",
  SHIPMENTS_TABLE_TABLE_EXPORTED = "dashboard.shipment.shipmentTable.exported",
  SHIPMENTS_TABLE_INDEX_CONFIGURATION = "dashboard.shipment.index.configuration",
  SHIPMENTS_TABLE_INDEX_CLOSE = "dashboard.shipment.index.close",
  SHIPMENTS_TABLE_INDEX_SUBMITTING = "dashboard.shipment.index.submitting",
  SHIPMENTS_TABLE_INDEX_SUBMITTED = "dashboard.shipment.index.submitted",
  SHIPMENTS_TABLE_HEADER_TRACKER = "dashboard.shipment.header.tracker",
  SHIPMENTS_TABLE_HEADER_RECOVER_FUNDS = "dashboard.shipment.header.recoverFunds",
  SHIPMENTS_TABLE_HEADER_PRACTICAL_APPROACH = "dashboard.shipment.header.practicalApproach",
  SHIPMENTS_TABLE_HEADER_MISSING_INVENTORY = "dashboard.shipment.header.missingInventory",
  SHIPMENTS_TABLE_HEADER_STEP1 = "dashboard.shipment.header.step1",
  SHIPMENTS_TABLE_HEADER_AMAZON_ACCOUNT = "dashboard.shipment.header.amazonAccount",
  SHIPMENTS_TABLE_HEADER_STEP2 = "dashboard.shipment.header.step2",
  SHIPMENTS_TABLE_HEADER_FILTER = "dashboard.shipment.header.filter",
  SHIPMENTS_TABLE_HEADER_STEP3 = "dashboard.shipment.header.step3",
  SHIPMENTS_TABLE_HEADER_CREATE_TICKETS = "dashboard.shipment.header.createTickets",
  SHIPMENTS_TABLE_HEADER_STEP4 = "dashboard.shipment.header.step4",
  SHIPMENTS_TABLE_HEADER_ADD_DETAILS = "dashboard.shipment.header.addDetails",
  SHIPMENTS_TABLE_HEADER_INVENTORY = "dashboard.shipment.header.inventory",
  SHIPMENT_STATUS_TABLE_NAME = "dashboard.shipment.statusTable.name",
  SHIPMENT_STATUS_TABLE_ID = "dashboard.shipment.statusTable.id",
  SHIPMENT_STATUS_TABLE_UPDATED = "dashboard.shipment.statusTable.updated",
  SHIPMENT_STATUS_TABLE_CREATED = "dashboard.shipment.statusTable.created",
  SHIPMENT_STATUS_TABLE_SHIP_TO = "dashboard.shipment.statusTable.shipTo",
  SHIPMENT_STATUS_TABLE_SKU = "dashboard.shipment.statusTable.sku",
  SHIPMENT_STATUS_TABLE_UNITS = "dashboard.shipment.statusTable.units",
  SHIPMENT_STATUS_TABLE_UNITS_received = "dashboard.shipment.statusTable.unitsReceived",
  SHIPMENT_STATUS_TABLE_SHIPMENT_EVENT = "dashboard.shipment.statusTable.shipmentEvent",
  SHIPMENT_STATUS_TABLE_NO_DATA = "dashboard.shipment.statusTable.noData",
  SHIPMENT_STATUS_TABLE_PROGRESS = "dashboard.shipment.statusTable.progress",
  SHIPMENT_STATUS_TABLE_COMPLETE = "dashboard.shipment.statusTable.complete",
  SHIPMENT_STATUS_TABLE_EXPORTED = "dashboard.shipment.statusTable.exported",
  TABLE_PAGINATION = "rows",
  DRAWER_LAYOUT_DASHBOARD = "drawerLayout.dashboard",
  DRAWER_LAYOUT_INVENTORY = "drawerLayout.inventory",
  DRAWER_LAYOUT_REPLENISHMENT = "drawerLayout.replenishment",
  DRAWER_LAYOUT_SHIPMENTS = "drawerLayout.shipments",
  DRAWER_LAYOUT_FULFILLMENTFEES = "drawerLayout.fulFillmentFees",
  DRAWER_LAYOUT_FORECASTING = "drawerLayout.forecasting",
  DRAWER_LAYOUT_REPORTS = "drawerLayout.reports",
  DRAWER_LAYOUT_SALES_VIEW_REPORTS = "drawerLayout.salesViewReports",
  DRAWER_LAYOUT_SALES_CHANGES = "drawerLayout.salesChanges",
  DRAWER_LAYOUT_PERFORMANCE = "drawerLayout.performance",
  DRAWER_LAYOUT_PAYMENTS = "drawerLayout.payments",
  DRAWER_LAYOUT_CATALOG = "drawerLayout.catalog",
  DRAWER_LAYOUT_LISTING_HEALTH = "drawerLayout.listingHealth",
  DRAWER_LAYOUT_CATALOG_TRACKER = "drawerLayout.catalogTracker",
  DRAWER_LAYOUT_ADVERTISING = "drawerLayout.advertising",
  DRAWER_LAYOUT_PROMOTIONAL_CALENDAR = "drawerLayout.promotionalCalender",
  FORECASTING_TABLE_SELLER = "dashboard.forcasting.forecastingTable.seller",
  FORECASTING_TABLE_ASIN = "dashboard.forcasting.forecastingTable.asin",
  FORECASTING_TABLE_DESCRIPTION = "dashboard.forcasting.forecastingTable.description",
  FORECASTING_TABLE_FORECAST = "dashboard.forcasting.forecastingTable.forecast",
  FORECASTING_TABLE_ADJUSTING = "dashboard.forcasting.forecastingTable.adjusting",
  FORECASTING_TABLE_FORECAST_2 = "dashboard.forcasting.forecastingTable.forecast2",
  FORECASTING_TABLE_SIMPLE_AVERAGE = "dashboard.forcasting.forecastingTable.simpleAverage",
  FORECASTING_TABLE_FORECAST_3 = "dashboard.forcasting.forecastingTable.forecast3",
  FORECASTING_TABLE_30_DAY = "dashboard.forcasting.forecastingTable.30Day",
  FORECASTING_TABLE_MEDIAN = "dashboard.forcasting.forecastingTable.median",
  FORECASTING_TABLE_DAILY_SALES = "dashboard.forcasting.forecastingTable.dailySales",
  FORECASTING_TABLE_PERCENTILE = "dashboard.forcasting.forecastingTable.percentile",
  FORECASTING_TABLE_PERCENTILE_TOOLTIP = "dashboard.forcasting.forecastingTable.percentileToolTip",
  FORECASTING_TABLE_CHANGES = "dashboard.forcasting.forecastingTable.changes",
  FORECASTING_TABLE_RECALCULATE = "dashboard.forcasting.forecastingTable.recalculate",
  FORECASTING_TABLE_CLOSE = "dashboard.forcasting.forecastingTable.close",
  FORECASTING_TABLE_PROGRESS = "dashboard.forcasting.forecastingTable.progress",
  FORECASTING_TABLE_COMPLETE = "dashboard.forcasting.forecastingTable.complete",
  FORECASTING_TABLE_EXPORTED = "dashboard.forcasting.forecastingTable.exported",
  FORECASTING_EDIT_TABLE_SELLER = "dashboard.forcasting.forecastingEditTable.seller",
  FORECASTING_EDIT_TABLE_ASIN = "dashboard.forcasting.forecastingEditTable.asin",
  FORECASTING_EDIT_TABLE_DESCRIPTION = "dashboard.forcasting.forecastingEditTable.description",
  FORECASTING_EDIT_TABLE_DAILY_SALES = "dashboard.forcasting.forecastingEditTable.dailySales",
  FORECASTING_EDIT_TABLE_ADJUSTMENT = "dashboard.forcasting.forecastingEditTable.adjustment",
  FORECASTING_EDIT_TABLE_ADJUSTMENT_DROPDOWN = "dashboard.forcasting.forecastingEditTable.adjustmentDropDown",
  FORECASTING_EDIT_TABLE_ADJUSTMENT_DROPDOWN_Y = "dashboard.forcasting.forecastingEditTable.adjustmentDropDownY",
  FORECASTING_EDIT_TABLE_ADJUSTMENT_DROPDOWN_N = "dashboard.forcasting.forecastingEditTable.adjustmentDropDownN",
  FORECASTING_EDIT_TABLE_STOCK = "dashboard.forcasting.forecastingEditTable.stock",
  FORECASTING_EDIT_TABLE_DAYS = "dashboard.forcasting.forecastingEditTable.days",
  FORECASTING_EDIT_TABLE_BOTTOM_PERCENTILE = "dashboard.forcasting.forecastingEditTable.percentile",
  FORECASTING_EDIT_TABLE_DATA_POINTS = "dashboard.forcasting.forecastingEditTable.dataPoints",
  FORECASTING_EDIT_TABLE_DATA_POINTS_SELECT = "dashboard.forcasting.forecastingEditTable.dataPointsSelect",
  FORECASTING_EDIT_TABLE_FACTOR = "dashboard.forcasting.forecastingEditTable.factor",
  FORECASTING_EDIT_TABLE_ANAMOLIES = "dashboard.forcasting.forecastingEditTable.anamolies",
  FORECASTING_EDIT_TABLE_ANAMOLIES_SELECT = "dashboard.forcasting.forecastingEditTable.anamoliesSelect",
  FORECASTING_EDIT_TABLE_NO_ADJUSTMENT = "dashboard.forcasting.forecastingEditTable.noAdjustment",
  FORECASTING_EDIT_TABLE_PRICE_POINTS = "dashboard.forcasting.forecastingEditTable.pricePoints",
  FORECASTING_EDIT_TABLE_PRICE_EXCLUDE_POINTS = "dashboard.forcasting.forecastingEditTable.excludePoints",
  FORECASTING_EDIT_TABLE_FORECAST_TYPE = "dashboard.forcasting.forecastingEditTable.forecastType",
  FORECASTING_EDIT_TABLE_ADJUSTING_FACTOR = "dashboard.forcasting.forecastingEditTable.adjustingFactor",
  FORECASTING_EDIT_TABLE_OPTION_2 = "dashboard.forcasting.forecastingEditTable.option2",
  FORECASTING_EDIT_TABLE_OPTION_3 = "dashboard.forcasting.forecastingEditTable.option3",
  FORECASTING_EDIT_TABLE_MEDIAN = "dashboard.forcasting.forecastingEditTable.median",
  FORECASTING_EDIT_TABLE_PERCENTILE = "dashboard.forcasting.forecastingEditTable.percentileNos",
  FORECASTING_EDIT_TABLE_SUBMITTING = "dashboard.forcasting.forecastingEditTable.submitting",
  FORECASTING_EDIT_TABLE_SUBMITTED = "dashboard.forcasting.forecastingEditTable.submitted",
  FORECASTING_EDIT_TABLE_NOTE = "dashboard.forcasting.forecastingEditTable.note",
  FORECASTING_EDIT_TABLE_CHANGES = "dashboard.forcasting.forecastingEditTable.changes",
  FORECASTING_EDIT_TABLE_SAVE = "dashboard.forcasting.forecastingEditTable.save",
  FORECASTING_EDIT_TABLE_CLOSE = "dashboard.forcasting.forecastingEditTable.close",
  FORECASTING_EDIT_TABLE_PROGRESS = "dashboard.forcasting.forecastingEditTable.progress",
  FORECASTING_EDIT_TABLE_COMPLETE = "dashboard.forcasting.forecastingEditTable.complete",
  FORECASTING_EDIT_TABLE_EXPORTED = "dashboard.forcasting.forecastingEditTable.exported",
  FORECASTING_CHART_ASIN = "dashboard.forcasting.chart.asin",
  FORECASTING_CHART_UNITS = "dashboard.forcasting.chart.units",
  FORECASTING_CHART_NO_DATA = "dashboard.forcasting.chart.noData",
  FORECASTING_CHART_PERCENTILE = "dashboard.forcasting.chart.percentile",
  FORECASTING_CHART_AVERAGE = "dashboard.forcasting.chart.average",
  FORECASTING_CHART_MEDIAN = "dashboard.forcasting.chart.median",
  FORECASTING_CHART_DAILY_FORECAST = "dashboard.forcasting.chart.dailyForecast",
  FORECASTING_CHART_ASIN_1 = "dashboard.forcasting.chart.asin1",
  FORECASTING_CHART_SELLER = "dashboard.forcasting.chart.seller",
  FORECASTING_CHART_DECRIPTION = "dashboard.forcasting.chart.description",
  FORECASTING_HEADER_FORECASTING = "dashboard.forcasting.header.forcasting",
  FORECASTING_HEADER_SHORT_TERM = "dashboard.forcasting.header.shortTerm",
  FORECASTING_HEADER_STOCKS = "dashboard.forcasting.header.stocks",
  FORECASTING_HEADER_FORECAST = "dashboard.forcasting.header.forecast",
  FORECASTING_HEADER_STEP1 = "dashboard.forcasting.header.step1",
  FORECASTING_HEADER_SELLER_PAGE = "dashboard.forcasting.header.sellerPage",
  FORECASTING_HEADER_STEP2 = "dashboard.forcasting.header.step2",
  FORECASTING_HEADER_FILTER = "dashboard.forcasting.header.filter",
  FORECASTING_HEADER_STEP3 = "dashboard.forcasting.header.step3",
  FORECASTING_HEADER_OPTIONAL = "dashboard.forcasting.header.optional",
  FORECASTING_HEADER_GLOBAL_SETTINGS = "dashboard.forcasting.header.global",
  FORECASTING_HEADER_INPUT = "dashboard.forcasting.header.input",
  FORECASTING_HEADER_SUBMIT = "dashboard.forcasting.header.submit",
  FORECASTING_HEADER_AND = "dashboard.forcasting.header.and",
  FORECASTING_HEADER_BACK = "dashboard.forcasting.header.back",
  FORECASTING_HEADER_SEASONAL = "dashboard.forcasting.header.seasonal",
  FORECASTING_HEADER_NUMERIC = "dashboard.forcasting.header.numeric",
  FORECASTING_HEADER_STOCK_DAYS = "dashboard.forcasting.header.days",
  FORECASTING_HEADER_OPTION = "dashboard.forcasting.header.option",
  FORECASTING_HEADER_DATA = "dashboard.forcasting.header.data",
  FORECASTING_HEADER_NUMBER = "dashboard.forcasting.header.number",
  FORECASTING_HEADER_ANAMOLIES = "dashboard.forcasting.header.anamolies",
  FORECASTING_HEADER_PERCENTILE = "dashboard.forcasting.header.percentile",
  FORECASTING_HEADER_EXCLUDE = "dashboard.forcasting.header.exclude",
  FORECASTING_HEADER_REMOVE_PRICES = "dashboard.forcasting.header.removePrices",
  FORECASTING_HEADER_RECENCY_WEIGHT = "dashboard.forcasting.header.recencyWeight",
  FORECASTING_HEADER_CHOICE = "dashboard.forcasting.header.choice",
  FORECASTING_HEADER_TYPE = "dashboard.forcasting.header.type",
  FORECASTING_HEADER_MEDIAN = "dashboard.forcasting.header.median",
  FORECASTING_HEADER_STEP4 = "dashboard.forcasting.header.step4",
  FORECASTING_HEADER_EXCEL = "dashboard.forcasting.header.excel",
  FORECASTING_DIMENSION_SELLER = "dashboard.fillfillmentFees.dimensionTable.seller",
  FORECASTING_DIMENSION_ASIN = "dashboard.fillfillmentFees.dimensionTable.asin",
  FORECASTING_DIMENSION_SKU = "dashboard.fillfillmentFees.dimensionTable.sku",
  FORECASTING_DIMENSION_PRODUCT_NAME = "dashboard.fillfillmentFees.dimensionTable.productName",
  FORECASTING_DIMENSION_PRODUCT_DAILY_SALES_1 = "dashboard.fillfillmentFees.dimensionTable.dailySales1",
  FORECASTING_DIMENSION_PRODUCT_DAILY_SAVINGS = "dashboard.fillfillmentFees.dimensionTable.dailySavings",
  FORECASTING_DIMENSION_PRODUCT_SAVINGS_UNIT = "dashboard.fillfillmentFees.dimensionTable.savingsUnit",
  FORECASTING_DIMENSION_LONGEST = "dashboard.fillfillmentFees.dimensionTable.longest",
  FORECASTING_DIMENSION_MEDIAN = "dashboard.fillfillmentFees.dimensionTable.median",
  FORECASTING_DIMENSION_SHORTEST = "dashboard.fillfillmentFees.dimensionTable.shortest",
  FORECASTING_DIMENSION_LENGTH = "dashboard.fillfillmentFees.dimensionTable.length",
  FORECASTING_DIMENSION_DIMENSION = "dashboard.fillfillmentFees.dimensionTable.dimension",
  FORECASTING_DIMENSION_ITEM = "dashboard.fillfillmentFees.dimensionTable.item",
  FORECASTING_DIMENSION_WEIGHT = "dashboard.fillfillmentFees.dimensionTable.weight",
  FORECASTING_DIMENSION_PRODUCT_SIZE = "dashboard.fillfillmentFees.dimensionTable.productSize",
  FORECASTING_DIMENSION_FBA_FEE = "dashboard.fillfillmentFees.dimensionTable.fbaFee",
  FORECASTING_DIMENSION_LONGEST_SIDE = "dashboard.fillfillmentFees.dimensionTable.longestSide",
  FORECASTING_DIMENSION_MEDIAN_SIDE = "dashboard.fillfillmentFees.dimensionTable.medianSide",
  FORECASTING_DIMENSION_SHORTEST_SIDE = "dashboard.fillfillmentFees.dimensionTable.shortestSide",
  FORECASTING_DIMENSION_NEW_LENGTH = "dashboard.fillfillmentFees.dimensionTable.newLength",
  FORECASTING_DIMENSION_NEW_UNIT = "dashboard.fillfillmentFees.dimensionTable.newUnit",
  FORECASTING_DIMENSION_ITEM_PACKAGE = "dashboard.fillfillmentFees.dimensionTable.itemPackage",
  FORECASTING_DIMENSION_NEW_UNIT_WEIGHT = "dashboard.fillfillmentFees.dimensionTable.newUnitWeight",
  FORECASTING_DIMENSION_SIZE_TIER = "dashboard.fillfillmentFees.dimensionTable.sizeTier",
  FORECASTING_DIMENSION_NEW_FBA_FEE = "dashboard.fillfillmentFees.dimensionTable.newFbaFee",
  FORECASTING_DIMENSION_BATTERY = "dashboard.fillfillmentFees.dimensionTable.battery",
  FORECASTING_DIMENSION_SMALL = "dashboard.fillfillmentFees.dimensionTable.small",
  FORECASTING_DIMENSION_DANGEROUS = "dashboard.fillfillmentFees.dimensionTable.dangerous",
  FORECASTING_DIMENSION_FILLED = "dashboard.fillfillmentFees.dimensionTable.filled",
  FORECASTING_DIMENSION_RECALCULATE = "dashboard.fillfillmentFees.dimensionTable.recalculate",
  FORECASTING_DIMENSION_CLOSE = "dashboard.fillfillmentFees.dimensionTable.close",
  FORECASTING_DIMENSION_PROGRESS = "dashboard.fillfillmentFees.dimensionTable.progress",
  FORECASTING_DIMENSION_COMPLETE = "dashboard.fillfillmentFees.dimensionTable.complete",
  FORECASTING_DIMENSION_EXPORTED = "dashboard.fillfillmentFees.dimensionTable.exported",
  FORECASTING_FBA_AVERAGE = "dashboard.fillfillmentFees.fba.average",
  FORECASTING_FBA_ESTIMATED_SAVINGS = "dashboard.fillfillmentFees.fba.savings",
  FORECASTING_FBA_AMAZON_LONGEST = "dashboard.fillfillmentFees.fba.longest",
  FORECASTING_FBA_AMAZON_MEDIAN = "dashboard.fillfillmentFees.fba.median",
  FORECASTING_FBA_AMAZON_SHORTEST = "dashboard.fillfillmentFees.fba.shortest",
  FORECASTING_FBA_AMAZON_LENGTH = "dashboard.fillfillmentFees.fba.length",
  FORECASTING_FBA_AMAZON_WEIGHT = "dashboard.fillfillmentFees.fba.weight",
  FORECASTING_FBA_AMAZON_FBA = "dashboard.fillfillmentFees.fba.fba",
  FORECASTING_FBA_SELLER_SIDE = "dashboard.fillfillmentFees.fba.side",
  FORECASTING_FBA_SELLER_MEDIAN_SIDE = "dashboard.fillfillmentFees.fba.medianSide",
  FORECASTING_FBA_SELLER_SHORTEST_SIDE = "dashboard.fillfillmentFees.fba.shortestSide",
  FORECASTING_FBA_SELLER_LENGTH_GIRTH = "dashboard.fillfillmentFees.fba.lengthGirth",
  FORECASTING_FBA_SELLER_UNIT_DIMENSION = "dashboard.fillfillmentFees.fba.unitDimension",
  FORECASTING_FBA_SELLER_ITEM_PACKAGE = "dashboard.fillfillmentFees.fba.itemPackage",
  FORECASTING_FBA_SELLER_UNIT_WEIGHT = "dashboard.fillfillmentFees.fba.unitWeight",
  FORECASTING_FBA_DANGEROUS_GOODS = "dashboard.fillfillmentFees.fba.dangerousGoods",
  FORECASTING_FBA_FIELDS = "dashboard.fillfillmentFees.fba.fields",
  FORECASTING_FBA_RECALCULATE = "dashboard.fillfillmentFees.fba.recalculate",
  FORECASTING_FBA_CLOSE = "dashboard.fillfillmentFees.fba.close",
  FULFILLMENT_FEES_RANGER_WEIGHT = "dashboard.fillfillmentFees.ranger.weight",
  FULFILLMENT_FEES_RANGER_POUNDS = "dashboard.fillfillmentFees.ranger.pounds",
  FULFILLMENT_FEES_RANGER_GRAMS = "dashboard.fillfillmentFees.ranger.grams",
  FULFILLMENT_FEES_RANGER_INCHES = "dashboard.fillfillmentFees.ranger.inches",
  FULFILLMENT_FEES_RANGER_CMS = "dashboard.fillfillmentFees.ranger.cms",
  FULFILLMENT_FEES_RANGER_UNITS = "dashboard.fillfillmentFees.ranger.units",
  FULFILLMENT_FEES_RANGER_LENGTH = "dashboard.fillfillmentFees.ranger.length",
  FULFILLMENT_FEES_RANGER_WIDTH = "dashboard.fillfillmentFees.ranger.width",
  FULFILLMENT_FEES_RANGER_HEIGHT = "dashboard.fillfillmentFees.ranger.height",
  FULFILLMENT_FEES_RANGER_YES = "dashboard.fillfillmentFees.ranger.yes",
  FULFILLMENT_FEES_RANGER_NO = "dashboard.fillfillmentFees.ranger.no",
  FULFILLMENT_FEES_RANGER_SMALL = "dashboard.fillfillmentFees.ranger.small",
  FULFILLMENT_FEES_RANGER_BATTERY = "dashboard.fillfillmentFees.ranger.battery",
  FULFILLMENT_FEES_RANGER_DANGEROUS = "dashboard.fillfillmentFees.ranger.dangerous",
  FULFILLMENT_FEES_RANGER_FIELDS = "dashboard.fillfillmentFees.ranger.fields",
  FULFILLMENT_FEES_RANGER_TABLE_FBA = "dashboard.fillfillmentFees.rangerTable.fba",
  FULFILLMENT_FEES_RANGER_TABLE_LENGTH = "dashboard.fillfillmentFees.rangerTable.length",
  FULFILLMENT_FEES_RANGER_TABLE_WIDTH = "dashboard.fillfillmentFees.rangerTable.width",
  FULFILLMENT_FEES_RANGER_TABLE_HEIGHT = "dashboard.fillfillmentFees.rangerTable.height",
  FULFILLMENT_FEES_RANGER_TABLE_WEIGHT = "dashboard.fillfillmentFees.rangerTable.weight",
  FULFILLMENT_FEES_RANGER_TABLE_CATEGORY = "dashboard.fillfillmentFees.rangerTable.category",
  FULFILLMENT_FEES_RANGER_TABLE_UNIT = "dashboard.fillfillmentFees.rangerTable.unit",
  FULFILLMENT_FEES_RANGER_TABLE_UNIT_WEIGHT = "dashboard.fillfillmentFees.rangerTable.unitWeight",
  FULFILLMENT_FEES_RANGER_TABLE_SMALL = "dashboard.fillfillmentFees.rangerTable.small",
  FULFILLMENT_FEES_RANGER_TABLE_BATTERY = "dashboard.fillfillmentFees.rangerTable.battery",
  FULFILLMENT_FEES_RANGER_TABLE_GOODS3 = "dashboard.fillfillmentFees.rangerTable.goods3",
  FULFILLMENT_FEES_HEADER_TOOLTIP = "dashboard.fillfillmentFees.header.toolTip",
  FULFILLMENT_FEES_HEADER_INVENTORY = "dashboard.fillfillmentFees.header.inventory",
  FULFILLMENT_FEES_HEADER_FEES = "dashboard.fillfillmentFees.header.fees",
  USER_MENU_SELLER = "userMenu.seller",
  PRICING_PLAN_TITLE = "pricingPlan.title",
  SALES_DASHBOARD_DATE = "performanceDashboard.table.date",
  SALES_DASHBOARD_SALES = "performanceDashboard.table.sales",
  SALES_DASHBOARD_SALES_GOALS = "performanceDashboard.table.salesGoals",
  SALES_DASHBOARD_DIFFERENCE = "performanceDashboard.table.difference",
  SALES_DASHBOARD_PERCENT_DIFFERENCE = "performanceDashboard.table.percentDifference",
  SALES_DASHBOARD_UNITS = "performanceDashboard.table.units",
  SALES_DASHBOARD_GOAL = "performanceDashboard.table.goal",
  SALES_DASHBOARD_DIFFERENCE_UNITS = "performanceDashboard.table.diffUnits",
  SALES_DASHBOARD_DIFFERENCE_UNITS_PERCENT = "performanceDashboard.table.diffUnitsPercent",
  SALES_DASHBOARD_NOTE = "performanceDashboard.table.note",
  SALES_DASHBOARD_NO_DATA = "performanceDashboard.table.noData",
  SALES_DASHBOARD_PROGRESS = "performanceDashboard.table.progress",
  SALES_DASHBOARD_COMPLETE = "performanceDashboard.table.complete",
  SALES_DASHBOARD_EXPORTED = "performanceDashboard.table.exported",
  DASHBOARD_FILTERS_TOP_ASINS = "performanceDashboard.dashboardFilters.asins",
  DASHBOARD_FILTERS_TOP_INC = "performanceDashboard.dashboardFilters.inc",
  DASHBOARD_FILTERS_TOP_DEC = "performanceDashboard.dashboardFilters.dec",
  DASHBOARD_FILTERS_TYPE = "performanceDashboard.dashboardFilters.type",
  DASHBOARD_FILTERS_AGGREGATION = "performanceDashboard.dashboardFilters.aggregation",
  DASHBOARD_FILTERS_CATEGORY = "performanceDashboard.dashboardFilters.category",
  DASHBOARD_FILTERS_TOTAL_RECORDS = "performanceDashboard.dashboardFilters.records",
  DASHBOARD_FILTERS_SHIPMENTS = "performanceDashboard.dashboardFilters.shipments",
  DASHBOARD_FILTERS_FRAMES = "performanceDashboard.dashboardFilters.frames",
  DASHBOARD_FILTERS_DOLLARS = "performanceDashboard.dashboardFilters.dollars",
  DASHBOARD_FILTERS_UNITS = "performanceDashboard.dashboardFilters.units",
  DASHBOARD_FILTERS_EDIT = "performanceDashboard.dashboardFilters.edit",
  DASHBOARD_FILTERS_RANK = "performanceDashboard.dashboardFilters.rank",
  DASHBOARD_FILTERS_CHART = "performanceDashboard.dashboardFilters.chart",
  DASHBOARD_FILTERS_CAMPAIGN = "performanceDashboard.dashboardFilters.campaign",
  DASHBOARD_FILTERS_CONFIGURATIONS = "performanceDashboard.dashboardFilters.configs",
  SALES_DASHBOARD_CHART_SALES = "performanceDashboard.chart.sales",
  SALES_DASHBOARD_CHART_SALES_$ = "performanceDashboard.chart.sales$",
  SALES_DASHBOARD_CHART_SALES_UNITS = "performanceDashboard.chart.salesUnits",
  PERFORMANCE_DASHBOARD_HEADER_DASHBOARD = "performanceDashboard.header.dashboard",
  PERFORMANCE_DASHBOARD_HEADER_PULSE = "performanceDashboard.header.pulse",
  PERFORMANCE_DASHBOARD_HEADER_PRODUCT = "performanceDashboard.header.product",
  PERFORMANCE_DASHBOARD_HEADER_REVIEW = "performanceDashboard.header.review",
  PERFORMANCE_DASHBOARD_HEADER_STEP1 = "performanceDashboard.header.step1",
  PERFORMANCE_DASHBOARD_HEADER_AMAZON_ACCOUNT = "performanceDashboard.header.account",
  PERFORMANCE_DASHBOARD_HEADER_STEP_2 = "performanceDashboard.header.step2",
  PERFORMANCE_DASHBOARD_HEADER_FILTER = "performanceDashboard.header.filter",
  PERFORMANCE_DASHBOARD_HEADER_STEP_3 = "performanceDashboard.header.step3",
  PERFORMANCE_DASHBOARD_HEADER_DASHBOARDS = "performanceDashboard.header.dashboards",
  PERFORMANCE_DASHBOARD_HEADER_SALES_DASHBOARD = "performanceDashboard.header.salesDashboards",
  PERFORMANCE_DASHBOARD_HEADER_SALES_BREAKOUT = "performanceDashboard.header.salesBreakout",
  PERFORMANCE_DASHBOARD_HEADER_ITEM = "performanceDashboard.header.item",
  PERFORMANCE_DASHBOARD_HEADER_INVENTORY = "performanceDashboard.header.inventory",
  PERFORMANCE_DASHBOARD_HEADER_FBA = "performanceDashboard.header.fba",
  PERFORMANCE_DASHBOARD_HEADER_ADVERTISING = "performanceDashboard.header.advertising",
  PERFORMANCE_DASHBOARD_HEADER_RANK = "performanceDashboard.header.rank",
  SALES_BREAKOUT_INDEX_DATE = "performanceDashboard.index.date",
  SALES_BREAKOUT_INDEX_CONFIGURATION = "performanceDashboard.index.config",
  SALES_BREAKOUT_INDEX_CLOSE = "performanceDashboard.index.close",
  PRICING_PLAN_SUBTITLE = "pricingPlan.subtitle",
  PRICING_PLAN_BUYBTN = "pricingPlan.getStartBtn",
  PRICING_TITLE_MONTH = "pricingPlan.monthTitle",
  PRICING_CONTENT_MONTH = "pricingPlan.monthContent",
  PRICING_TITLE_QUARTER = "pricingPlan.quarterTitle",
  PRICING_TITLE_AUTOPAY = "pricingPlan.autoPayTitle",
  PRICING_TITLE_YEAR = "pricingPlan.yearTitle",
  PRICING_CONTENT_QUARTER = "pricingPlan.quarterContent",
  PRICING_CONTENT_YEAR = "pricingPlan.yearContent",
  PRICING_CONTENT_AUTOPAY = "pricingPlan.autoPayContent",
  PRICING_CONTENT_AUTOPAY_INFO = "pricingPlan.autoPayInfo",
  PRICING_BEST_SELLER = "pricingPlan.bestSeller",
  SUBSCRIBE_MSG_DISPLAY = "trialSubsMsg",
  PRICING_TITLE_MONTH_SIGNUP = "tryFreeOption.month",
  PRICING_TITLE_QUARTER_SIGNUP = "tryFreeOption.quarter",
  PRICING_TITLE_YEAR_SIGNUP = "tryFreeOption.year",
  PRICING_TITLE_AUTOPAY_SIGNUP = "tryFreeOption.autoPay",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_ASIN = "performanceDashboard.advertisingTable.asin",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_SPEND = "performanceDashboard.advertisingTable.spend",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_IMPRESSIONS = "performanceDashboard.advertisingTable.impressions",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_CLICKS = "performanceDashboard.advertisingTable.clicks",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_SALES_UNITS = "performanceDashboard.advertisingTable.salesUnits",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_SALES = "performanceDashboard.advertisingTable.sales",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_COST_CLICK = "performanceDashboard.advertisingTable.costClick",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_CLICK_RATE = "performanceDashboard.advertisingTable.clickRate",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_CONVERSION_RATE = "performanceDashboard.advertisingTable.conversionRate",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_AD_SALES = "performanceDashboard.advertisingTable.adSales",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_AD_SALES_UNITS = "performanceDashboard.advertisingTable.adSalesUnits",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_NO_DATA = "performanceDashboard.advertisingTable.noData",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_PROGRESS = "performanceDashboard.advertisingTable.progress",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_COMPLETE = "performanceDashboard.advertisingTable.complete",
  PERFORMANCE_DASHBOARD_ADVERTISING_TABLE_EXPORTED = "performanceDashboard.advertisingTable.exported",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_ASIN = "performanceDashboard.rankChangesView.asin",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_SEARCH_TERMS = "performanceDashboard.rankChangesView.searchTerms",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_SEARCH_TERMS_TOOLTIP = "performanceDashboard.rankChangesView.searchTermsToolTip",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_NO_DATA = "performanceDashboard.rankChangesView.noData",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_SUBMITTING = "performanceDashboard.rankChangesView.submitting",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_CHANGES = "performanceDashboard.rankChangesView.changes",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_SAVE = "performanceDashboard.rankChangesView.save",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_CLOSE = "performanceDashboard.rankChangesView.close",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_TABLE_ASIN = "performanceDashboard.rankChangesTable.asin",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_TABLE_SEARCH_TERMS = "performanceDashboard.rankChangesTable.searchTerms",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_TABLE_RANK = "performanceDashboard.rankChangesTable.rank",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_TABLE_RANK_CHANGE = "performanceDashboard.rankChangesTable.rankChange",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_TABLE_DAILY_SALE = "performanceDashboard.rankChangesTable.dailySale",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_TABLE_NO_DATA = "performanceDashboard.rankChangesTable.noData",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_TABLE_PROGRESS = "performanceDashboard.rankChangesTable.progress",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_TABLE_COMPLETE = "performanceDashboard.rankChangesTable.complete",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_TABLE_EXPORTED = "performanceDashboard.rankChangesTable.exported",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_CHART_RANK = "performanceDashboard.rankChangesChart.rank",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_CHART_SEARCH = "performanceDashboard.rankChangesChart.search",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_CHART_ASIN = "performanceDashboard.rankChangesChart.asin",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_CHART_RANK_CHART = "performanceDashboard.rankChangesChart.rankChart",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_CHART_DAILY_SALES = "performanceDashboard.rankChangesChart.dailySales",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_CHART_COLOURED_SECTION = "performanceDashboard.rankChangesChart.colouredSection",
  PERFORMANCE_DASHBOARD_RANK_CHANGES_CHART_NO_DATA = "performanceDashboard.rankChangesChart.noData",
  PERFORMANCE_DASHBOARD_SUMMARY_CHART_METRICS = "performanceDashboard.summaryChartComp.metrics",
  PERFORMANCE_DASHBOARD_SALES_CHART_CHANGE = "performanceDashboard.salesChart.change",
  PERFORMANCE_DASHBOARD_SALES_CHART_TRAILING = "performanceDashboard.salesChart.trailing",
  PERFORMANCE_DASHBOARD_SALES_CHART_NO_DATA = "performanceDashboard.salesChart.noData",
  PERFORMANCE_DASHBOARD_SALES_CHART_CHANGE_PERCENT = "performanceDashboard.salesChart.changePercent",
  PERFORMANCE_DASHBOARD_SALES_CHART_EXPECTED_AVG = "performanceDashboard.salesChart.expectedAvg",
  PERFORMANCE_DASHBOARD_SALES_CHART_ACTUAL_AVG = "performanceDashboard.salesChart.actualAvg",
  PERFORMANCE_DASHBOARD_SALES_CHART_VARIANCE_CHANGE = "performanceDashboard.salesChart.varianceChange",
  PERFORMANCE_DASHBOARD_SALES_CHART_TRAILING_TIME = "performanceDashboard.salesChart.trailingTime",
  PERFORMANCE_DASHBOARD_SALES_BREAKOUT_NO_DATA = "performanceDashboard.salesBreakoutTable.noData",
  PERFORMANCE_DASHBOARD_SALES_BREAKOUT_CHART_SALES = "performanceDashboard.salesBreakoutChart.sales",
  PERFORMANCE_DASHBOARD_SALES_BREAKOUT_CHART_NO_DATA = "performanceDashboard.salesBreakoutChart.noData",
  LANDING_PAGE_HEADER_DEMO_VIDEO = "landingPageHeader.demoVideo",
  LANDING_PAGE_HEADER_DEMO = "landingPageHeader.demo",
  LANDING_PAGE_HEADER_FEATURES = "landingPageHeader.features",
  LANDING_PAGE_HEADER_IMPROVE_CATALOG_HEALTH = "landingPageHeader.improveCatalogHealth",
  LANDING_PAGE_HEADER_STREAMLINE_SUPPLY_CHAIN = "landingPageHeader.streamlineSupplyChain",
  LANDING_PAGE_HEADER_BUSSINESS_GROWTH = "landingPageHeader.bussinessGrowth",
  LANDING_PAGE_HEADER_SELLER_ACCOUNTS = "landingPageHeader.sellerAccounts",
  LANDING_PAGE_HEADER_PRICING = "landingPageHeader.pricing",
  LANDING_PAGE_HEADER_DASHBOARD = "landingPageHeader.dashBoard",
  LANDING_PAGE_MAIN_SECTION_SIGNUP = "landingPageMainSection.signUp",
  LANDING_PAGE_MAIN_SECTION_TRY_APP = "landingPageMainSection.tryApp",
  LANDING_PAGE_MAIN_SECTION_MANAGE = "landingPageMainSection.manage",
  LANDING_PAGE_MAIN_SECTION_ALL = "landingPageMainSection.all",
  LANDING_PAGE_MAIN_SECTION_SELLER_ACCOUNT = "landingPageMainSection.sellerAccount",
  LANDING_PAGE_MAIN_SECTION_ONE_TOOL = "landingPageMainSection.oneTool",
  LANDING_PAGE_MAIN_SECTION_EXPLORE = "landingPageMainSection.explore",
  LANDING_PAGE_MAIN_SECTION_EACH_TOOL = "landingPageMainSection.eachTool",
  LANDING_PAGE_MAIN_SECTION_APP_BUILT = "landingPageMainSection.appBuilt",
  LANDING_PAGE_MAIN_SECTION_FORMER = "landingPageMainSection.former",
  LANDING_PAGE_MAIN_SECTION_PROFITABILITY = "landingPageMainSection.profitability",
  LANDING_PAGE_MAIN_SECTION_TASKS = "landingPageMainSection.tasks",
  LANDING_PAGE_MAIN_SECTION_IMPROVE = "landingPageMainSection.improve",
  LANDING_PAGE_MAIN_SECTION_HEALTH = "landingPageMainSection.health",
  LANDING_PAGE_MAIN_SECTION_FLAG = "landingPageMainSection.flag",
  LANDING_PAGE_MAIN_SECTION_SEE_DEMO = "landingPageMainSection.seeDemo",
  LANDING_PAGE_MAIN_SECTION_STREAMLINE = "landingPageMainSection.streamline",
  LANDING_PAGE_MAIN_SECTION_SUPPLY_CHAIN = "landingPageMainSection.supplyChain",
  LANDING_PAGE_MAIN_SECTION_SUPPLY_ANALYZE = "landingPageMainSection.analyze",
  LANDING_PAGE_MAIN_SECTION_BUSSINESS = "landingPageMainSection.business",
  LANDING_PAGE_MAIN_SECTION_REVIEW = "landingPageMainSection.review",
  LANDING_PAGE_MAIN_SECTION_CONNECT = "landingPageMainSection.connect",
  LANDING_PAGE_MAIN_SECTION_SELLER_ACCOUNTS = "landingPageMainSection.sellerAccounts",
  LANDING_PAGE_MAIN_SECTION_SELLERS = "landingPageMainSection.sellers",
  LANDING_PAGE_MAIN_GET_STARTED = "landingPageMainSection.getStarted",
  LANDING_PAGE_MAIN_GET_ACHIEVE = "landingPageMainSection.achevive",
  LANDING_PAGE_MAIN_GET_SELLER_APP = "landingPageMainSection.sellerApp",
  LANDING_PAGE_MAIN_GET_OUR_TOOLS = "landingPageMainSection.ourTools",
  LANDING_PAGE_MAIN_SECTION_TRY_FREE = "landingPageMainSection.tryFree",
  LANDING_PAGE_MAIN_SECTION_FOOTER = "landingPageMainSection.footer",
  LANDING_PAGE_MAIN_SECTION_FREE_TRIAL = "landingPageMainSection.freeTrial",
  LANDING_PAGE_MAIN_SECTION_NO_CARD = "landingPageMainSection.noCard",
  LANDING_PAGE_LOGIN_EMAIL = "landingPageLogin.email",
  LANDING_PAGE_LOGIN_PASSWORD = "landingPageLogin.password",
  LANDING_PAGE_LOGIN_SIGNUP = "landingPageLogin.signup",
}
export default I18nKey;
